import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiGift } = FiIcons;

const Footer = () => {
  const footerLinks = [
    {
      title: 'Daily Verses',
      links: [
        { path: '/bible-verse-of-the-day', label: 'Verse of the Day' },
        { path: '/daily-bible-verse', label: 'Daily Verse' },
        { path: '/bible-passage-of-the-day', label: 'Bible Passage' }
      ]
    },
    {
      title: 'Topics',
      links: [
        { path: '/healing-scriptures', label: 'Healing' },
        { path: '/bible-verses-about-strength', label: 'Strength' },
        { path: '/encouraging-verses', label: 'Encouraging' },
        { path: '/bible-verses-about-hope', label: 'Hope' }
      ]
    },
    {
      title: 'Quick Links',
      links: [
        { path: '/jeremiah-29-11', label: 'Jeremiah 29:11' },
        { path: '/romans-8-28', label: 'Romans 8:28' },
        { path: '/isaiah-41-10', label: 'Isaiah 41:10' },
        { path: '/psalm-23', label: 'Psalm 23' }
      ]
    },
    {
      title: 'Legal',
      links: [
        { path: '/privacy-policy', label: 'Privacy Policy' },
        { path: '/terms-of-use', label: 'Terms of Use' }
      ]
    }
  ];

  return (
    <footer className="bg-gray-900 text-white border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-3 mb-6 group">
              <img 
                src="https://cdn1.sharemyimage.com/smi/2026/01/24/Encouraging-Bible-Verses-Logo-Clear.png" 
                alt="Encouraging Bible Verses" 
                className="h-14 w-auto transition-transform duration-300 group-hover:scale-105"
                loading="lazy"
                width="56"
                height="56"
              />
              <span className="text-xl font-bold tracking-tight text-white">
                Encouraging Bible Verses
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed max-w-sm">
              Discover the healing power and encouragement of God&apos;s Word through carefully curated Bible verses 
              for strength, hope, faith, and peace.
            </p>
          </div>

          <div className="grid grid-cols-2 lg:col-span-3 gap-8">
            {footerLinks.map((section) => (
              <div key={section.title}>
                <h3 className="text-xs font-bold text-indigo-400 uppercase tracking-widest mb-4">
                  {section.title}
                </h3>
                <ul className="space-y-2">
                  {section.links.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className="text-gray-400 hover:text-white text-sm transition-colors block py-0.5"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-sm">
          <p className="text-gray-500 mb-4 md:mb-0">
            © {new Date().getFullYear()} Encouraging Bible Verses. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <Link to="/christian-gifts" className="flex items-center space-x-1.5 text-gray-400 hover:text-white transition-colors">
              <SafeIcon icon={FiGift} className="h-4 w-4 text-indigo-400" />
              <span>Gifts</span>
            </Link>
            <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
              X (Twitter)
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default memo(Footer);